import orderStatuses from '@/helpers/orderStatuses'

export default function () {
    return {
        data: [],
        fields: [
            {
                key: 'id',
                label: 'ID Pedido'
            },
            {
                key: 'placeName',
                label: 'Destino'
            },
            {
                key: 'status',
                label: 'Status'
            },
            {
                key: 'date',
                label: 'Data do pedido'
            },
            {
                key: 'duration',
                label: 'Data da trip'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ],
        orderStatuses
    }
}
